<int-integrators-details
                         [creating]="creating"
                         [integrationName]="integrationName"
                         [integrationType]="integrationType"
                         [user]="user"
                         [invites]="invites"></int-integrators-details>
<div mat-dialog-content>
  <div *ngIf="creating" class="int-text-container">
    {{description}}
  </div>

  <div fxLayout="row" fxLayoutAlign="center">
    <div (click)="onClick($event)" *ngIf="creating && !accounts.length && !loading" class="microsoft-btn">
      <img class="microsoft-icon-svg" src="../../assets/image/ms-sign-in-btn.svg" />
    </div>
  </div>

  <mat-progress-spinner *ngIf="loading" diameter="40" mode="indeterminate"></mat-progress-spinner>

  <p *ngIf="creating" class="int-text-container">
    Click the sign in with microsoft button to authorize Advocado, then select the account you would like to use. If
    your account is managed by an Agency, be sure to select the lowest possible child account, not the manager account.
  </p>

  <div *ngIf="creating && accounts && accounts.length">
    <mat-form-field>
      <mat-label>Account</mat-label>
      <mat-select [(ngModel)]="createdIntegration.accountId" [disabled]="createdIntegration.accountLinked">
        <mat-option *ngFor="let account of accounts" [value]="account.accountId">
          {{ account.customerName + ' - ' + account.accountName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-error *ngIf="creating && noAccounts"
    >No Bing Ads Accounts found! Try using a different Microsoft Account.</mat-error
  >

  <div *ngIf="isAdmin && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      <mat-icon>add</mat-icon>
      <span class="center-text">ADD ANOTHER ACCOUNT</span>
    </button>
  </div>

  <div *ngIf="!noAccounts && !creating">
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
      <mat-icon>expand_more</mat-icon>
      <span>SHOW CONNECTED ACCOUNTS</span>
    </button>
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
      <mat-icon>expand_less</mat-icon>
      <span>HIDE CONNECTED ACCOUNTS</span>
    </button>
  </div>

  <div *ngIf="!creating" [hidden]="!showAccounts">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <div *ngFor="let int of existingIntegrations">Account Name: {{ int.friendlyName }}</div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>CANCEL</button>
    <button *ngIf="disconnectOnDestroy" mat-raised-button (click)="save()" class="install-button">SAVE</button>
  </div>
</div>
